export const EVENT_KEY_NAME = '$track_get_started_modal_click'
